<!--page starts-->
 <section class="page-wrapper">
    <div class="player-staff-section margin-top-152 cf">
    	
    	<div class="player-staff-section-inner cf">
	    	<div class="player-staff-bg"></div>
	    	<div class="container">
	    		<div class="player-staff-detail cf">
	    			<div class="player-staff-tab">
	    				<ul>
							<li class="courses-name active " id="first-players"><a href="#">First Team</a></li>
							<li class="courses-name " id="womens"><a href="#">Women's Team</a></li>
							<!-- <li class="courses-name " id="academy"><a href="#">Academy</a></li> -->
	    					<li class="courses-name " id="coaching-staff"><a href="#">Coaching Staff</a></li>
	    				</ul>
	    			</div>
	    			<div class="player-staff-tab-detail course-main-content " id="coaching-staff-content">
	    			
	    				<div class="player-staff-detail-box cf">
			    				<div class="player-staff-box coaching slide" *ngFor="let coaching of playerCoachingList?.data; let i = index">
			    					<a [routerLink]="['/player-single', coaching?.slug]">
				    					<img [src]="coaching?.image">
										<div class="player-staff-box-overlay">
											<p>{{coaching?.first_name}}</p>
											<h4>{{coaching?.last_name}}</h4>
										</div>
										
				    				</a>
			    				</div>
			    				
			    				<div class="news-tab-btn">
		                            <a href="javascript:void(0);" id="loadMore">View More</a>
				      	 		</div>
		    			</div>
	    			</div>
	    			<div class="player-staff-tab-detail course-main-content active" id="first-players-content">
	    				
	    				<div class="player-staff-detail-box cf">	    					
			    				<div class="player-staff-box first-players slide" *ngFor="let man of playerManList?.data; let i = index">
			    					<a [routerLink]="['/player-single', man?.slug]">
				    					<img [src]="man?.image">
										<div class="player-staff-box-overlay">
											<p>{{man?.first_name}}</p>
											<h4>{{man?.last_name}}</h4>
										</div>
										<div class="player-staff-overlay-number">
											<h3>{{man?.players_number}}</h3>
										</div>
				    				</a>
			    				</div>
			    				
			    			    <div class="news-tab-btn">
		                            <a href="javascript:void(0);" id="loadMoreone">View More</a>
				      	 		</div>
		    			</div>
	    			</div>
	    			<!-- <div class="player-staff-tab-detail course-main-content " id="academy-content">
	    				
	    				<div class="player-staff-detail-box cf">	    					
			    				<div class="player-staff-box academy-players slide" *ngFor="let academy of playerAcademyList?.data; let i = index">
			    					<a [routerLink]="['/player-single', academy?.slug]">
				    					<img [src]="academy?.image">
										<div class="player-staff-box-overlay">
											<p>{{academy?.first_name}}</p>
											<h4>{{academy?.last_name}}</h4>
										</div>
										
				    				</a>
			    				</div>
			    				
			    			    <div class="news-tab-btn">
		                            <a href="javascript:void(0);" id="loadMorethree">View More</a>
				      	 		</div>
		    			</div>
	    			</div> -->
	    			<div class="player-staff-tab-detail course-main-content " id="womens-content">
	    				
	    				<div class="player-staff-detail-box cf">
			    				<div class="player-staff-box women-players slide" *ngFor="let woman of playerWomanList?.data; let i = index"> 
			    					<a [routerLink]="['/player-single', woman?.slug]">
				    					<img [src]="woman?.image">
										<div class="player-staff-box-overlay">
											<p>{{woman?.first_name}}</p>
											<h4>{{woman?.last_name}}</h4>
										</div>
										<div class="player-staff-overlay-number">
											<h3>{{woman?.players_number}}</h3>
										</div>
				    				</a>
			    				</div>
			    				
			    			    <div class="news-tab-btn">
		                            <a href="javascript:void(0);" id="loadMoretwo">View More</a>
				      	 		</div>
		    			</div>
	    			</div>
	    		</div>
	    	</div>
	    </div>
	</div>
</section><!-- page ends-->